// test2595
(2595 && 0);
